<script lang="ts" setup>
defineOptions({
  inheritAttrs: false,
});

const attrs = useAttrs() as {
  class: string;
  srcUrl: string;
  poster: string;
};

console.log('attrs in SectionHero.vue:', attrs);
</script>

<template>
  <div class="section-hero w-full h-full relative" v-bind="attrs">
    <BackgroundVideo v-if="attrs['src-url']" v-bind="attrs" />

    <div class="section-hero-content">
      <slot />
    </div>
  </div>
</template>

<style lang="scss">
@use '@/assets/scss/queries';
.section-hero {
  height: 100vh;
  position: relative;

  @include queries.for-size(device) {
    height: 100vh;
    max-height: 100vh;
  }
}
</style>
